import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import Navbar from "./header/Navbar";
import Analysis from "./views/Analysis/Analysis";
import Homepage from "./views/Homepage/Homepage";
import Loader from "./header/Loader";
import ROI from "./views/ROI/ROI";
import Footer from "./footer/Footer";

function App() {
  const loader = useSelector((state) => state.Loader.state);

  return (
    <>
      <Router>
        {loader === "false" ? <Loader /> : <Navbar />}
        <Switch>
          <Route path="/historicalroi" component={ROI} />
          <Route path="/convertcommunity" component={Analysis} />
          <Route path="/" component={Homepage} />
          <Redirect to='/'/>
        </Switch>
        {loader === "false" ? '' : <Footer />}
      </Router>
    </>
  );
}

export default App;
